import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function CTASection() {
  const {
    lang
  } = useLanguage();
  const stats = [{
    number: '100+',
    label: lang === 'es' ? 'Negocios lanzados' : 'Businesses launched'
  }, {
    number: '100%',
    label: lang === 'es' ? 'Satisfacción garantizada' : 'Guaranteed satisfaction'
  }, {
    number: lang === 'es' ? '< 2 sem' : '< 2 wks',
    label: lang === 'es' ? 'Tiempo promedio' : 'Average time'
  }];
  return <section style={{
    background: '#FAFAFA',
    padding: '100px 24px'
  }} data-id="element-67">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="relative overflow-hidden mx-auto" style={{
      background: 'linear-gradient(135deg, #4a3666 0%, #5a4579 50%, #8B6BA8 100%)',
      borderRadius: '32px',
      padding: '80px 24px',
      maxWidth: '960px',
      boxShadow: '0 40px 100px rgba(90,69,121,0.3)'
    }} data-id="element-68">
        {/* Decorative orbs */}
        <div className="absolute pointer-events-none" style={{
        top: '-80px',
        right: '-80px',
        width: '300px',
        height: '300px',
        borderRadius: '50%',
        background: 'rgba(255,255,255,0.06)'
      }} aria-hidden="true" data-id="element-69" />
        <div className="absolute pointer-events-none" style={{
        bottom: '-60px',
        left: '-60px',
        width: '200px',
        height: '200px',
        borderRadius: '50%',
        background: 'rgba(255,255,255,0.04)'
      }} aria-hidden="true" data-id="element-70" />

        {/* Decorative dot grid */}
        <div className="absolute pointer-events-none hidden md:block" style={{
        right: '60px',
        top: '60px',
        opacity: 0.1,
        width: '120px',
        height: '120px',
        backgroundImage: 'radial-gradient(circle, #FFFFFF 1.5px, transparent 1.5px)',
        backgroundSize: '24px 24px'
      }} aria-hidden="true" data-id="element-71" />

        <div className="relative mx-auto text-center px-2 md:px-12" style={{
        maxWidth: '720px'
      }} data-id="element-72">
          {/* Label */}
          <p style={{
          color: 'rgba(255,255,255,0.6)',
          fontSize: '11px',
          fontWeight: 700,
          letterSpacing: '2px',
          textTransform: 'uppercase',
          textAlign: 'center'
        }} data-id="element-73">
            {lang === 'es' ? 'Da el siguiente paso' : 'Take the next step'}
          </p>

          {/* Title */}
          <h2 className="text-[32px] md:text-[44px]" style={{
          color: '#FFFFFF',
          fontWeight: 900,
          textAlign: 'center',
          lineHeight: 1.2,
          marginTop: '8px',
          letterSpacing: '-0.02em'
        }} data-id="element-74">
            {lang === 'es' ? '¿Listo para construir tu base digital?' : 'Ready to build your digital foundation?'}
          </h2>

          {/* Subtitle */}
          <p className="mx-auto" style={{
          color: 'rgba(255,255,255,0.75)',
          fontSize: '18px',
          textAlign: 'center',
          maxWidth: '480px',
          margin: '16px auto 48px',
          lineHeight: 1.6
        }} data-id="element-75">
            {lang === 'es' ? 'Más de 100 negocios digitales lanzados con Inkova. El tuyo puede ser el siguiente.' : 'Over 100 digital businesses launched with Inkova. Yours can be the next one.'}
          </p>

          {/* Stats */}
          <div className="flex justify-center flex-wrap" style={{
          gap: '60px',
          marginBottom: '48px',
          paddingBottom: '48px',
          borderBottom: '1px solid rgba(255,255,255,0.15)'
        }} data-id="element-76">
            {stats.map((s, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.15 + i * 0.08
          }} style={{
            textAlign: 'center'
          }} data-id="element-77">
                <div style={{
              fontSize: '40px',
              fontWeight: 900,
              color: '#FFFFFF',
              lineHeight: 1
            }} data-id="element-78">
                  {s.number}
                </div>
                <div style={{
              fontSize: '13px',
              color: 'rgba(255,255,255,0.6)',
              marginTop: '6px'
            }} data-id="element-79">
                  {s.label}
                </div>
              </motion.div>)}
          </div>

          {/* CTAs */}
          <div className="flex justify-center flex-wrap" style={{
          gap: '16px'
        }} data-id="element-80">
            <a href="#planes" className="group inline-flex items-center gap-2 transition-all duration-300" style={{
            background: '#FFFFFF',
            color: '#5a4579',
            borderRadius: '14px',
            padding: '18px 48px',
            fontSize: '16px',
            fontWeight: 800,
            boxShadow: '0 8px 32px rgba(0,0,0,0.2)'
          }} onMouseEnter={e => {
            ;
            (e.currentTarget as HTMLAnchorElement).style.transform = 'translateY(-2px)';
          }} onMouseLeave={e => {
            ;
            (e.currentTarget as HTMLAnchorElement).style.transform = 'translateY(0)';
          }} data-id="element-81">
              <span data-id="element-82">
                {lang === 'es' ? 'Quiero empezar hoy' : 'I want to start today'}
              </span>
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" data-id="element-83" />
            </a>

            <a href="https://wa.me/17863037695?text=Hola%2C%20tengo%20preguntas%20sobre%20Inkova%20y%20quiero%20escribir%20primero" target="_blank" rel="noopener noreferrer" className="inline-flex items-center transition-all duration-300" style={{
            background: 'transparent',
            border: '2px solid rgba(255,255,255,0.4)',
            color: '#FFFFFF',
            borderRadius: '14px',
            padding: '18px 32px',
            fontSize: '15px',
            fontWeight: 600
          }} onMouseEnter={e => {
            ;
            (e.currentTarget as HTMLAnchorElement).style.borderColor = '#FFFFFF';
          }} onMouseLeave={e => {
            ;
            (e.currentTarget as HTMLAnchorElement).style.borderColor = 'rgba(255,255,255,0.4)';
          }} data-id="element-84">
              {lang === 'es' ? 'Tengo preguntas, escribir primero' : 'I have questions, message first'}
            </a>
          </div>

          {/* Guarantee */}
          <p style={{
          color: 'rgba(255,255,255,0.5)',
          fontSize: '12px',
          textAlign: 'center',
          marginTop: '24px'
        }} data-id="element-85">
            {lang === 'es' ? 'Sin compromiso · Primera consulta sin costo · Todo en español' : 'No commitment · First consultation free · Everything in English'}
          </p>
        </div>
      </motion.div>
    </section>;
}